import { GetIntercomJWTResponse } from "@vitable/asclepius-api-client-ts"
import useAsclepius from "@common/composables/api/asclepius"
import { QueryApiCacheKeys } from "@common/config/query-api-cache-keys"
import { queryClient } from "@/services/query-client"

export function fetchIntercomJwt(userId: string): Promise<string> {
  const { getUtilityApi, callWithResponse } = useAsclepius()

  return queryClient.fetchQuery({
    queryKey: [QueryApiCacheKeys.INTERCOM_JWT, userId],
    queryFn: async (): Promise<string> => {
      const data: GetIntercomJWTResponse = await callWithResponse(() => getUtilityApi().getIntercomJwt())
      return data.token
    }
  })
}
